var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    fillRule: "evenodd",
    d: "m3.355 8.106 1.25-1.25.962.961c.586.586 1.058.77 1.923.096.193-.192.53-.432.914-.24l1.827 1.25c.53.433.572.67.433 1.01-.865 2.114-3.606 1.78-7.31-1.827m0 0C-.252 4.403-.587 1.66 1.527.796c.341-.139.577-.096 1.01.433l1.25 1.828c.193.384-.048.72-.24.913-.673.866-.49 1.338.096 1.924l.962.961z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export default ForwardRef;